import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-x2" }
const _hoisted_2 = {
  key: 0,
  id: "bien-ban-kiem-nghiem-printing-modal",
  class: "printing-paper"
}
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-4 d-flex flex-column align-items-center",
  style: {"font-size":"0.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, "Mẫu số 02-VT"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, "(Ban hành theo QĐ số: 200/2014/TT-BTC"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-nowrap mb-0" }, "Ngày 22/12/2014 của Bộ trưởng BTC)")
], -1)
const _hoisted_6 = { class: "row mb-5" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, " BIÊN BẢN KIỂM NGHIỆM SẢN PHẨM. VẬT TƯ, HÀNG HÓA ", -1)
const _hoisted_9 = { class: "text-center mb-0" }
const _hoisted_10 = { class: "text-center mb-0" }
const _hoisted_11 = { class: "text-center mb-0" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 px-5" }
const _hoisted_14 = { class: "break-word" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-12 px-5" }
const _hoisted_17 = { style: {"width":"100%"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "TT"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Họ và tên"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Chức vụ chuyên môn"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Thành phần trong hội đồng")
], -1)
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "mb-0 mt-3" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12 px-5" }
const _hoisted_26 = { style: {"width":"100%","font-size":"0.8rem"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center",
      width: "30"
    }, "TT"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center break-word"
    }, " Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm, hàng hóa "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center",
      width: "50"
    }, "Mã số"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center break-word",
      width: "40"
    }, " ĐVT "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center break-word"
    }, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center break-word"
    }, " SL theo hóa đơn "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center break-word"
    }, " Kết quả kiểm nghiệm "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      class: "text-center break-word"
    }, " Phương thức kiểm nghiệm ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Đạt"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Không đạt")
  ])
], -1)
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "✓")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "row mt-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_39 = { class: "col-8" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Ý kiến của hội đồng kiểm nghiệm:", -1)
const _hoisted_41 = {
  key: 0,
  class: "d-flex justify-content-around"
}
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "(Ký, họ tên)", -1)
const _hoisted_44 = { class: "text-center text-capitalize m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_dialog_auto_focus = _resolveDirective("dialog-auto-focus")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpen) = $event)),
    width: "80%",
    onClose: _ctx.onClose
  }, {
    title: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      (_ctx.bienBanData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_PdfDocumentHeader, {
                  "ten-don-vi": _ctx.tenDonVi,
                  "ten-don-vi-cha": _ctx.tenDonViCha
                }, null, 8, ["ten-don-vi", "ten-don-vi-cha"])
              ]),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.ngayBienBanDisplay), 1)
                ]),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("strong", null, "Biên bản kiểm nghiệm số: " + _toDisplayString(_ctx.bienBanData?.so_bien_ban), 1)
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("strong", null, "Kho: " + _toDisplayString(_ctx.bienBanData?.phieu_nhap_kho.kho?.ten_kho ?? ''), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, [
                  _createTextVNode(" Căn cứ theo quyết định của giám đốc "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.tenGiamDocDisplay), 1),
                  _createTextVNode(" về việc thành lập hội đồng kiểm nghiệm. Hội đồng kiểm nghiệm gồm các ông (bà) có tên sau đây: ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  _hoisted_18,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thanhPhanItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.thuTu), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.hoTen), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.chucVu), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.thanhPhan), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("p", _hoisted_23, [
                  _createTextVNode(" Đã tiến hành kiểm nghiệm các loại vật tư theo hợp đồng số "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.hopDongData?.so_hop_dong || '.......................'), 1),
                  _createTextVNode(" ngày "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.ngayHopDongDisplay), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("table", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bienBanData.vat_tu_bien_ban_kiem_nghiem, (vatTu, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_28, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(vatTu.ten_vat_tu), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(vatTu.ma_vat_tu), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(vatTu.don_vi_tinh ? vatTu.don_vi_tinh : '-'), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.donGiaVatTuDisplay(vatTu)), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatQuantity(vatTu.pivot.so_luong)), 1),
                        _hoisted_34,
                        _hoisted_35,
                        _createElementVNode("td", _hoisted_36, _toDisplayString(vatTu.pivot.phuong_thuc_kiem_nghiem
											? vatTu.pivot.phuong_thuc_kiem_nghiem
											: '-'), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("p", null, [
                  _hoisted_40,
                  _createTextVNode(" " + _toDisplayString(_ctx.bienBanData.y_kien), 1)
                ])
              ])
            ]),
            (!!_ctx.bienBanData.thanh_phan_hoi_dong)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thanhPhanItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "d-inline-flex flex-column align-content-between justify-content-between",
                      style: {"height":"120px"},
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h6", _hoisted_42, "Thành phần " + _toDisplayString(item.thuTu), 1),
                        _hoisted_43
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_44, _toDisplayString(item.hoTen), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_DivRow, { class: "mt-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_DivCol, { cols: 10 }),
            _createVNode(_component_DivCol, {
              cols: 2,
              class: "text-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.PRINT,
                  onClick: _ctx.onPrintingButtonClicked
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("In biên bản")
                  ]),
                  _: 1
                }, 8, ["button-type", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])), [
        [_directive_dialog_auto_focus, _ctx.isOpen]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}